import type { FC } from "react";
import styles from "../MatchPrediction.module.scss";
import classnames from "classnames";
import { isNonEmptyString } from "@/utils/type-guards/isNonEmptyStringGuard";

interface HeaderProps {
  readonly title: string;
  readonly subtitle: string;
  totalOfVotes: number;
}
export const HeaderFC: FC<HeaderProps> = (props) => {
  const { title, subtitle, totalOfVotes } = props;
  return (
    <header className={styles.header}>
      <p className={classnames("title-7-bold", styles.title)}>{title}</p>
      {isNonEmptyString(subtitle) && (
        <p className={classnames("title-8-bold", styles.subtitle)}>
          <span className={styles.totalOfVotes}>{totalOfVotes}</span>
          {subtitle}
        </p>
      )}
    </header>
  );
};
